var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar',{attrs:{"flat":""}},[_c('v-toolbar-title',[_vm._t("default")],2),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.$slots.actions)?[_vm._t("actions")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }